__turbopack_context__.v({
  "button": "D3eu2q_button",
  "container": "D3eu2q_container",
  "content": "D3eu2q_content",
});
